import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkurkumbhdaundhmidc() {



  const cardData =
  {
    keyword: ' Cab Service in Kurkumbh Daund MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service in Kurkumbh Daund MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Cab Service in Kurkumbh Daund MIDC, designed to meet the transportation needs of manufacturing units, industrial plants, and corporate offices in the region. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures comfortable and timely travel for employees, managers, and visiting business guests. Whether it is daily employee pickup and drop, plant visits, airport transfers, or executive travel, we deliver safe, punctual, and hassle-free mobility solutions. With trained chauffeurs, flexible rental options, and dedicated service support, Pune Corporate Cars India Private Limited ensures a smooth and premium travel experience for companies operating in Kurkumbh and Daund MIDC.',

    top: 'Top Places to Visit in Kurkumbh Daund with Pune Corporate Car',

  "topPlaces": [
  {
    "title": "Bhuleshwar Temple",
    "description": "An ancient Shiva temple near Daund, featuring unique hill-top architecture and carved stone work. It offers panoramic views of the surrounding countryside."  
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "A famous Ashtavinayak Ganesha temple located on the northern bank of the Bhima River, close to Daund. A spiritually uplifting pilgrimage site."  
  },
  {
    "title": "Bhima River Ghats",
    "description": "The serene banks of the Bhima River in Daund make for a peaceful spot — ideal for picnics, early morning walks, and bird-watching."  
  },
  {
    "title": "Shri Vitthal Rukmini Mandir, Daund",
    "description": "A well-known temple in the heart of Daund dedicated to Lord Vitthal and Rukmini, drawing devotees especially on religious occasions."  
  },
  {
    "title": "Kashti Datta Mandir",
    "description": "A temple dedicated to Lord Dattatreya located close to Daund — a quiet, spiritual place nestled in nature."  
  },
  {
    "title": "Bahadurgad Fort (Pedgaon Fort)",
    "description": "Historic ruins of a fort near Daund, offering views over the Bhima River and a peek into the region’s Maratha-era past."  
  },
  {
    "title": "Narayanbet Picnic Spot",
    "description": "A scenic spot near Chaufula (part of Daund region), known for its calm environment and natural beauty, perfect for day outings."  
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Shiv Smarak, Daund",
    "description": "A memorial dedicated to Shivaji Maharaj in Daund — a local landmark and place of historical significance."  
  }
],


"services": [
  {
    "name": "Kurkumbh Employee Shuttle",
    "description": "Kurkumbh Employee Shuttle provides reliable shuttle services for workers and corporate staff commuting to Kurkumbh MIDC. The service ensures punctual, safe, and well-managed daily employee transportation."
  },
  {
    "name": "Daund MIDC Staff Cab",
    "description": "Daund MIDC Staff Cab offers structured cab services for employees working in and around Daund MIDC. With trained drivers and GPS-enabled vehicles, the service ensures smooth daily commute operations."
  },
  {
    "name": "Worker Pickup Drop Daund",
    "description": "Worker Pickup Drop Daund delivers dependable pickup–drop transport solutions for factory and industrial workers in Daund. The service ensures timely shift-based commuting with safe travel practices."
  },
  {
    "name": "Corporate Cab Kurkumbh",
    "description": "Corporate Cab Kurkumbh offers dedicated corporate cab services for employees, managers, and visitors traveling within Kurkumbh MIDC. The service provides professional drivers and comfortable vehicles."
  },
  {
    "name": "Industrial Transport Kurkumbh",
    "description": "Industrial Transport Kurkumbh specializes in large-scale worker transportation for factories and industrial units. It ensures safe, organized, and timely travel for daily shift operations."
  },
  {
    "name": "Business Fleet Kurkumbh MIDC",
    "description": "Business Fleet Kurkumbh MIDC provides companies with a dedicated fleet of sedans, SUVs, and staff cabs for corporate and industrial travel. The service ensures consistent availability and smooth operations."
  },
  {
    "name": "Affordable Cab Kurkumbh",
    "description": "Affordable Cab Kurkumbh offers budget-friendly cab services for local travel, office commute, and industrial transportation. Ideal for staff and executives needing reliable daily travel."
  },
  {
    "name": "Monthly Cab Kurkumbh",
    "description": "Monthly Cab Kurkumbh provides long-term cab rental solutions for companies requiring consistent employee commute services. The service ensures reliable operations with fixed monthly plans."
  },
  {
    "name": "Best Employee Cab Kurkumbh",
    "description": "Best Employee Cab Kurkumbh delivers high-quality employee transportation services featuring trained drivers, clean vehicles, and punctual travel for all work shifts."
  },
  {
    "name": "Outstation Cab Kurkumbh",
    "description": "Outstation Cab Kurkumbh offers safe and comfortable long-distance travel for business trips, factory visits, and corporate travel needs from Kurkumbh to nearby cities."
  },
  {
    "name": "Sedan Cab Kurkumbh",
    "description": "Sedan Cab Kurkumbh provides premium sedan vehicles for corporate visitors, managers, and executive travel needs within Kurkumbh and surrounding regions."
  },
  {
    "name": "SUV Cab Kurkumbh",
    "description": "SUV Cab Kurkumbh offers spacious and comfortable SUVs suitable for team travel, industrial visits, and long-distance corporate trips from Kurkumbh MIDC."
  },
  {
    "name": "Factory Staff Transport Kurkumbh",
    "description": "Factory Staff Transport Kurkumbh specializes in large-scale worker commute solutions with structured routing, multi-shift support, and safe daily transport operations."
  },
  {
    "name": "Employee Mobility Kurkumbh",
    "description": "Employee Mobility Kurkumbh offers comprehensive mobility solutions for companies with workforce operations in Kurkumbh MIDC. It ensures reliable and efficient employee travel across shifts."
  },
  {
    "name": "Corporate Shuttle Kurkumbh",
    "description": "Corporate Shuttle Kurkumbh provides shuttle vans and minibuses for bulk staff transportation. Ideal for factories, warehouses, and corporate units requiring large-scale employee movement."
  }
],

"tableData": [
  ["Kurkumbh Employee Shuttle", "Daund MIDC Staff Cab"],
  ["Worker Pickup Drop Daund", "Corporate Cab Kurkumbh"],
  ["Industrial Transport Kurkumbh", "Business Fleet Kurkumbh MIDC"],
  ["Affordable Cab Kurkumbh", "Monthly Cab Kurkumbh"],
  ["Best Employee Cab Kurkumbh", "Outstation Cab Kurkumbh"],
  ["Sedan Cab Kurkumbh", "SUV Cab Kurkumbh"],
  ["Factory Staff Transport Kurkumbh", "Employee Mobility Kurkumbh"],
  ["Corporate Shuttle Kurkumbh", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Kurkumbh Daund MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and punctual cab services for employees and executives commuting to Kurkumbh Daund MIDC, ensuring hassle-free corporate travel."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drops",
    "WhyChoosedescription": "We ensure prompt pickup and drop services, helping employees reach their offices and industrial hubs in Kurkumbh Daund MIDC on time, every day."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs prioritize safety and professionalism, providing a comfortable and disciplined travel experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, well-serviced, and designed for safe and comfortable industrial commute."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to the commuting needs of businesses, employees, and industrial staff in Kurkumbh Daund MIDC."
  },
  {
    "WhyChooseheading": "24/7 Support for Corporate Commuting",
    "WhyChoosedescription": "Our team provides round-the-clock support to handle scheduling, emergencies, and route adjustments for uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Travel",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with safety features, ensuring a secure and hygienic ride for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient & Easy Booking",
    "WhyChoosedescription": "Corporate travel management is simplified through our smooth booking process, quick coordination, and dependable transportation services."
  }
]




























  }

const faqData = [
  {
    question: 'Do you provide cab services in Kurkumbh Daund MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional cab services for companies and employees in the Kurkumbh Daund MIDC area.',
  },
  {
    question: 'What type of cab services are available in Kurkumbh Daund MIDC?',
    answer: 'We provide employee transportation, corporate cab service, point-to-point pickup and drop, and dedicated shift-based transport solutions.',
  },
  {
    question: 'Do you offer daily employee transportation for Kurkumbh Daund MIDC companies?',
    answer: 'Yes, we provide daily commuting solutions including pick-up and drop services for employees working in Kurkumbh Daund MIDC.',
  },
  {
    question: 'How can companies book cab services for Kurkumbh Daund MIDC?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle options are available for the Kurkumbh Daund MIDC route?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and mini-buses based on company requirements and staff strength.',
  },
  {
    question: 'Can companies opt for monthly or long-term cab contracts?',
    answer: 'Yes, we offer flexible monthly, quarterly, and annual transportation contracts for corporate clients in the MIDC area.',
  },
  {
    question: 'Do you provide cab tracking and safety features?',
    answer: 'All our vehicles are GPS-enabled, regularly sanitized, and driven by trained and verified chauffeurs.',
  },
  {
    question: 'Do you support multiple shift timings for MIDC companies?',
    answer: 'Yes, we provide cab services tailored to multiple shift schedules, including night shifts.',
  },
  {
    question: 'What payment options are available for Kurkumbh Daund MIDC cab services?',
    answer: 'We support UPI, bank transfer, credit/debit cards, digital wallets, and corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Jagtap',
    feedback: 'Excellent cab service for our factory staff in Kurkumbh MIDC. Very professional drivers and timely operations.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Patwardhan',
    feedback: 'Reliable and well-organized transportation service for our employees in Daund MIDC. Highly recommended.',
    rating: 5,
  },
];



















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kurkumbh Daund MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-kurkumbh.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Kurkumbh Daund MIDC, Pune, including employee shuttles, staff pickup and drop, industrial transport, office commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely transport for companies and industrial units.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/cab-service-kurkumbh-daund-midc"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Service in Kurkumbh Daund MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides reliable corporate cab services in Kurkumbh Daund MIDC, Pune, including employee shuttles, staff pickup and drop, industrial transport, office commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely transport for companies and industrial units."
  />

  <meta
    name="keywords"
    content="Kurkumbh Employee Shuttle, Daund MIDC Staff Cab, Worker Pickup Drop Daund, Corporate Cab Kurkumbh, Industrial Transport Kurkumbh, Business Fleet Kurkumbh MIDC, Affordable Cab Kurkumbh, Monthly Cab Kurkumbh, Best Employee Cab Kurkumbh, Outstation Cab Kurkumbh, Sedan Cab Kurkumbh, SUV Cab Kurkumbh, Factory Staff Transport Kurkumbh, Employee Mobility Kurkumbh, Corporate Shuttle Kurkumbh"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkurkumbhdaundhmidc;